import React from "react";
import { CardTheme } from "./types";

interface CardBackgroundProps {
  color: string;
  theme: CardTheme;
}

export const CardBackground: React.FC<CardBackgroundProps> = React.memo(({ color, theme }) => {
  const { width, height, radius } = theme.card;
  const { background } = theme;
  
  // Generate unique clipPath ID using React.useId() for each card instance
  // This ensures no conflicts when multiple cards are rendered
  const clipPathId = React.useId().replace(/:/g, "-");

  return (
    <g>
      {/* Define clip path for rounded corners - unique per card instance */}
      <defs>
        <clipPath id={clipPathId}>
          <rect
            x={0}
            y={0}
            width={width}
            height={height}
            rx={radius}
            ry={radius}
          />
        </clipPath>
      </defs>

      {/* Base color background - always rendered first */}
      <rect
        x={0}
        y={0}
        width={width}
        height={height}
        rx={radius}
        ry={radius}
        fill={color}
        stroke="#000000"
        strokeWidth={2}
      />

      {/* Image overlay - only if background type is "image" */}
      {background.type === "image" && background.image && (
        <image
          href={background.image.src}
          x={0}
          y={0}
          width={width * (background.image.scale || 1)}
          height={height * (background.image.scale || 1)}
          preserveAspectRatio="xMidYMid slice"
          opacity={background.image.opacity ?? 1}
          clipPath={`url(#${clipPathId})`}
          style={{
            // Ensure image is loaded and cached
            imageRendering: "auto",
          }}
        />
      )}
    </g>
  );
});

CardBackground.displayName = "CardBackground";
